import React, { useState } from 'react';

const Pages = ({ children }) => {
  const [pageNumber, setPageNumber] = useState(0);
  const maxNumber = React.Children.count(children);
  const childrenArray = React.Children.toArray(children);
  return React.cloneElement(childrenArray[pageNumber], {
    next: () => {
      if (pageNumber + 1 < maxNumber) setPageNumber(pageNumber + 1);
    },
    back: () => {
      if (pageNumber - 1 > 0) setPageNumber(pageNumber - 1);
    },
  });
};

export default Pages;
